<admin-app-header></admin-app-header>
<div class="container-fluid admyt-page">
    <!-- Header with navigation -->
    <div class="row my-3">
        <div class="col-md-8">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <a [routerLink]="['/admin/admyt-users']">Admyt Users</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                        {{ getFullName() }}
                    </li>
                </ol>
            </nav>
        </div>
        <div class="col-md-4 text-end">
            <button (click)="goBack()" class="admyt-btn-secondary me-2"><i class="fa-solid fa-arrow-left"></i> Back</button>
            <button (click)="refreshData()" class="admyt-btn-secondary" [disabled]="loading">
                <i class="fa-solid fa-refresh" [class.fa-spin]="loading"></i> Refresh
            </button>
        </div>
    </div>

    <!-- Loading state -->
    <div *ngIf="loading" class="text-center my-5">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
        <p class="mt-2">Loading user details...</p>
    </div>

    <!-- Error state -->
    <div *ngIf="error" class="alert alert-danger">
        {{ error }}
        <button (click)="refreshData()" class="btn btn-outline-danger btn-sm ms-2">Try Again</button>
    </div>

    <!-- User details -->
    <div *ngIf="!loading && !error && user">
        <!-- Stat Cards -->
        <div class="admyt-stat-cards">
            <div class="admyt-stat-card admyt-stat-card--purple">
                <span class="data-source data-source--admyt"><i class="fa-solid fa-cloud"></i> Admyt</span>
                <div class="admyt-stat-card__icon">
                    <i class="fa-solid fa-user"></i>
                </div>
                <div class="admyt-stat-card__content">
                    <span class="admyt-stat-card__label">User</span>
                    <span class="admyt-stat-card__value">{{ getFullName() }}</span>
                </div>
            </div>
            
            <div class="admyt-stat-card admyt-stat-card--teal">
                <span class="data-source data-source--admyt"><i class="fa-solid fa-cloud"></i> Admyt</span>
                <div class="admyt-stat-card__icon">
                    <i class="fa-solid fa-car"></i>
                </div>
                <div class="admyt-stat-card__content">
                    <span class="admyt-stat-card__label">Registered Cars</span>
                    <span class="admyt-stat-card__value">{{ userCars.length }}</span>
                </div>
            </div>
            
            <div class="admyt-stat-card admyt-stat-card--blue" *ngIf="user.tenants && user.tenants.length > 0">
                <span class="data-source data-source--admyt"><i class="fa-solid fa-cloud"></i> Admyt</span>
                <div class="admyt-stat-card__icon">
                    <i class="fa-solid fa-id-card"></i>
                </div>
                <div class="admyt-stat-card__content">
                    <span class="admyt-stat-card__label">Tenants</span>
                    <span class="admyt-stat-card__value">{{ user.tenants.length }}</span>
                </div>
            </div>
            
            <div class="admyt-stat-card admyt-stat-card--green" *ngIf="linkedClient">
                <span class="data-source data-source--parkupp"><i class="fa-solid fa-database"></i> ParkUpp</span>
                <div class="admyt-stat-card__icon">
                    <i class="fa-solid fa-user-check"></i>
                </div>
                <div class="admyt-stat-card__content">
                    <span class="admyt-stat-card__label">Linked Client</span>
                    <a [routerLink]="['/admin/client', linkedClient.uid]" class="admyt-link">
                        {{ linkedClient.firstName }} {{ linkedClient.lastName }}
                    </a>
                </div>
            </div>
        </div>

        <!-- User Information Card -->
        <div class="admyt-card">
            <div class="admyt-card__header">
                <h3>
                    <i class="fa-solid fa-user me-2"></i>
                    User Details
                    <span class="data-source data-source--admyt"><i class="fa-solid fa-cloud"></i> Admyt</span>
                </h3>
                <div class="d-flex gap-2">
                    <a *ngIf="linkedClient" [routerLink]="['/admin/client', linkedClient.uid]" class="admyt-btn-primary">
                        <i class="fa-solid fa-user"></i> View ParkUpp Profile
                    </a>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <dl class="row mb-0">
                        <dt class="col-sm-4">User ID:</dt>
                        <dd class="col-sm-8">
                            <code>{{ user.id }}</code>
                        </dd>

                        <dt class="col-sm-4">Full Name:</dt>
                        <dd class="col-sm-8">
                            <strong>{{ getFullName() }}</strong>
                        </dd>

                        <dt class="col-sm-4">Email:</dt>
                        <dd class="col-sm-8">
                            {{ user.email }}
                        </dd>

                        <dt class="col-sm-4" *ngIf="user.status || user.isActive !== undefined">Status:</dt>
                        <dd class="col-sm-8" *ngIf="user.status || user.isActive !== undefined">
                            <span [class]="getStatusClass(user.status || user.isActive)">
                                {{ user.status || (user.isActive ? 'Active' : 'Inactive') }}
                            </span>
                        </dd>
                    </dl>
                </div>
                <div class="col-md-6">
                    <dl class="row mb-0">
                        <dt class="col-sm-4" *ngIf="user.createdAt">Created:</dt>
                        <dd class="col-sm-8" *ngIf="user.createdAt">
                            {{ user.createdAt | date: 'medium' }}
                        </dd>

                        <dt class="col-sm-4" *ngIf="user.updatedAt">Updated:</dt>
                        <dd class="col-sm-8" *ngIf="user.updatedAt">
                            {{ user.updatedAt | date: 'medium' }}
                        </dd>

                        <dt class="col-sm-4">ParkUpp Client:</dt>
                        <dd class="col-sm-8">
                            <a *ngIf="linkedClient" [routerLink]="['/admin/client', linkedClient.uid]" class="admyt-link">
                                <i class="fa-solid fa-user"></i> {{ linkedClient.firstName }} {{ linkedClient.lastName }}
                            </a>
                            <span *ngIf="!linkedClient" class="text-muted">
                                <i class="fa-solid fa-unlink"></i> Not linked
                            </span>
                            <span class="data-source data-source--parkupp ms-2"><i class="fa-solid fa-database"></i></span>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>

        <!-- User Cars -->
        <div class="admyt-card">
            <div class="admyt-card__header">
                <h4>
                    <i class="fa-solid fa-car me-2"></i>
                    Registered Cars
                    <span class="admyt-status admyt-status--active ms-2">{{ userCars.length }}</span>
                    <span class="data-source data-source--admyt ms-2"><i class="fa-solid fa-cloud"></i> Admyt</span>
                </h4>
            </div>

            <!-- Cars loading state -->
            <div *ngIf="carsLoading" class="text-center py-4">
                <i class="fa fa-spinner fa-spin"></i>
                Loading cars...
            </div>

            <!-- No cars message -->
            <div *ngIf="!carsLoading && userCars.length === 0" class="text-center py-5">
                <i class="fa-solid fa-car fa-2x text-muted"></i>
                <p class="mt-2 text-muted">No cars are currently registered for this user.</p>
            </div>

            <!-- Cars table -->
            <div *ngIf="!carsLoading && userCars.length > 0" class="table-responsive">
                <table class="admyt-table">
                    <thead>
                        <tr>
                            <th>License Plate</th>
                            <th>Make</th>
                            <th>Model</th>
                            <th>Added</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let car of userCars">
                            <td>
                                <strong>{{ car.plate }}</strong>
                            </td>
                            <td>{{ car.make }}</td>
                            <td>{{ car.model }}</td>
                            <td>
                                <span *ngIf="car.createdAt">{{ car.createdAt | date: 'medium' }}</span>
                                <span *ngIf="!car.createdAt" class="text-muted">N/A</span>
                            </td>
                            <td>
                                <button class="btn btn-outline-danger btn-sm" title="Delete car" (click)="deleteUserCar(car.plate)">
                                    <i class="fa-solid fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- User Tenants -->
        <div class="admyt-card" *ngIf="user.tenants && user.tenants.length > 0">
            <div class="admyt-card__header">
                <h4>
                    <i class="fa-solid fa-id-card me-2"></i>
                    Associated Tenants
                    <span class="admyt-status admyt-status--active ms-2">{{ user.tenants.length }}</span>
                    <span class="data-source data-source--admyt ms-2"><i class="fa-solid fa-cloud"></i> Admyt</span>
                </h4>
            </div>
            <div class="table-responsive">
                <table class="admyt-table">
                    <thead>
                        <tr>
                            <th>Tenant ID</th>
                            <th>Name</th>
                            <th>Linked Subscription <span class="data-source data-source--parkupp"><i class="fa-solid fa-database"></i></span></th>
                            <th>Centre ID</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let tenant of user.tenants">
                            <td>
                                <code>{{ truncate(tenant.id, 12) }}</code>
                            </td>
                            <td>
                                <strong>{{ tenant.name || 'Unknown Tenant' }}</strong>
                            </td>
                            <td>
                                <a *ngIf="getSubscriptionFromTenantName(tenant.name)" 
                                   [routerLink]="['/admin/subscription', getSubscriptionFromTenantName(tenant.name)]" 
                                   class="admyt-link">
                                    <i class="fa-solid fa-file-signature"></i>
                                    {{ truncate(getSubscriptionFromTenantName(tenant.name), 10) }}
                                </a>
                                <span *ngIf="!getSubscriptionFromTenantName(tenant.name)" class="text-muted">
                                    <i class="fa-solid fa-unlink"></i> Not linked
                                </span>
                            </td>
                            <td>
                                <code *ngIf="tenant.centreId">{{ truncate(tenant.centreId, 12) }}</code>
                                <span *ngIf="!tenant.centreId" class="text-muted">N/A</span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <a *ngIf="tenant.centreId"
                                       [routerLink]="['/admin/admyt-center', tenant.centreId, 'tenant', tenant.id]" 
                                       class="btn btn-outline-primary btn-sm" 
                                       title="View tenant">
                                        <i class="fa-solid fa-eye"></i>
                                    </a>
                                    <a *ngIf="getSubscriptionFromTenantName(tenant.name)" 
                                       [routerLink]="['/admin/subscription', getSubscriptionFromTenantName(tenant.name)]" 
                                       class="btn btn-outline-secondary btn-sm" 
                                       title="View subscription">
                                        <i class="fa-solid fa-file-signature"></i>
                                    </a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
